






































































import Vue from 'vue';
import { StepperWrapper } from '@/components/stepper-wrapper-component';
import { RouteTracking, FormValidation, CloseStepperWrapper } from '@/mixins';
import { AttachDocuments } from '@/components/my-documents-components/attach-documents-component';
import { DocumentDetailForm } from '@/components/my-documents-components/document-detail-form-component';
import { getContentArea } from '@/contentful';
import { LoadingService, ExtendMixins } from '@/services';
import { EventBus } from '@/event-bus';
import store from '@/store';
import { StepperSteps } from '@/@types/member';

interface Data {
  confirmBeforeClose: boolean;
  changeMade: boolean;
  submitIsLoading: boolean;
  showSubmitSuccessMessage: boolean;
  showSubmitErrorMessage: boolean;
  encryptedPDFError: boolean;
  badFileError: boolean;
  successMessage: string;
  errorMessage: string;
  errorEncryptedPDFMessage: string;
  errorBadFileMessage: string;
  guidelines: string;
  showWrapper: boolean;
  currentStep: number;
  file: any[];
  steps: StepperSteps[];
}

export default ExtendMixins(
  RouteTracking,
  CloseStepperWrapper,
  FormValidation,
).extend({
  name: 'UploadDocument',
  beforeRouteEnter(to, from, next) {
    const promises = [
      getContentArea([
        'upload-document-success',
        'upload-document-error',
        'upload-document-error-encrypted-pdf',
        'upload-document-error-bad-file',
        'attach-documents-guidelines',
      ]),
      store.dispatch('getMemberCustomerServiceInformation'),
    ];
    LoadingService.watchPromises(promises)
      .then((data) => {
        // Set content;
        const contentAreas = data[0];
        if (contentAreas) {
          if (contentAreas[0] && contentAreas[0].fields) {
            to.meta.successMessage = contentAreas[0].fields.content;
          }
          if (contentAreas[1] && contentAreas[1].fields) {
            to.meta.errorMessage = contentAreas[1].fields.content;
          }
          if (contentAreas[2] && contentAreas[2].fields) {
            to.meta.errorEncryptedPDFMessage = contentAreas[2].fields.content;
          }
          if (contentAreas[3] && contentAreas[3].fields) {
            to.meta.errorBadFileMessage = contentAreas[3].fields.content;
          }
          if (contentAreas[4] && contentAreas[4].fields) {
            to.meta.guidelines = contentAreas[4].fields.content;
          }
        }
        next();
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  data(): Data {
    return {
      confirmBeforeClose: true,
      changeMade: false,
      submitIsLoading: false,
      showSubmitSuccessMessage: false,
      showSubmitErrorMessage: false,
      encryptedPDFError: false,
      badFileError: false,
      successMessage: this.$route.meta.successMessage,
      errorMessage: this.$route.meta.errorMessage,
      errorEncryptedPDFMessage: this.$route.meta.errorEncryptedPDFMessage,
      errorBadFileMessage: this.$route.meta.errorBadFileMessage,
      guidelines: this.$route.meta.guidelines,
      showWrapper: true,
      currentStep: 1,
      file: [],
      steps: [
        {
          ref: 'attachDocument',
          name: 'upload-document_step_attach-document',
          stepPosition: 1,
          showBack: false,
          isCompleted: false,
          isEditable: false,
        },
        {
          ref: 'enterDetails',
          name: 'upload-document_step_enter-details',
          stepPosition: 2,
          showBack: true,
          isCompleted: false,
          isEditable: false,
        },
      ],
    };
  },
  computed: {
    hasAttachedFile(): boolean {
      return !!this.file.length;
    },
    selectedDocument(): any {
      if (this.hasAttachedFile) {
        const file = this.file[0];
        return {
          amount: 0,
          fileName: file.name,
          fileNickname: file.name,
          file,
        };
      }
      return null;
    },
    stepsMap(): any {
      return this.steps.reduce((map, obj) => {
        map[obj.ref] = obj;
        return map;
      }, {});
    },
  },
  methods: {
    setSelectedFile(file): void {
      this.file = file;
    },
    nextStep(): void {
      this.changeMade = true;
      if (this.currentStep < this.steps.length) {
        this.steps[this.currentStep - 1].isCompleted = true;
        this.currentStep++;
      }
    },
    setStep(step): void {
      this.currentStep = step;
    },
    updateConfirmBeforeClose(val): void {
      this.confirmBeforeClose = val;
    },
    toggleLoading(val): void {
      this.submitIsLoading = val;
    },
    hideWrapper(): void {
      this.showWrapper = false;
    },
  },
  components: {
    StepperWrapper,
    AttachDocuments,
    DocumentDetailForm,
  },
});
